import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Menu from './components/Menu';
import Gallery from './components/Gallery';
import Reservation from './components/Reservation';
import Footer from './components/Footer';
import MobileCallButton from './components/MobileCallButton';
import ReviewsSection from './components/ReviewsSection';
import Review from './pages/Review';
import Admin from './pages/Admin';
import useImageLoadObserver from './hooks/useImageLoadObserver';

function MainPage() {
  useImageLoadObserver();
  
  return (
    <>
      <Navigation />
      <main>
        <Hero />
        <About />
        <Menu />
        <Gallery />
        <Reservation />
        <ReviewsSection />
      </main>
      <Footer />
      <MobileCallButton />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App" data-testid="app-container">
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/review" element={<Review />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Toaster 
            position="top-right" 
            toastOptions={{
              style: {
                background: '#FFFFFF',
                border: '1px solid rgba(139, 41, 66, 0.2)',
                color: '#1A1A1D'
              }
            }}
          />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
